import type { AdminArticleListItem } from "@/types/article";
import type { ArticleAction } from "./article-columns";
import { ArticleCard } from "./article-card";

interface ArticleCardListProps {
  data: AdminArticleListItem[];
  onAction: (article: AdminArticleListItem, action: ArticleAction) => void;
}

export function ArticleCardList({ data, onAction }: ArticleCardListProps) {
  return (
    <div className="space-y-3">
      {data.map((article) => (
        <ArticleCard
          key={article._id}
          article={article}
          onAction={onAction}
        />
      ))}
    </div>
  );
}
